<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid"
                                                                                               :src="`${publicPath}app-assets/images/pages/illustration_phone.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;top: 70%;">
                <h3 class="text-white cursiveFont">Your True Business Companion</h3>
                <h3 class="text-white cursiveFont">Pay With Us!</h3>
                <p class="text-white mb-0 ">Easy And Quick Payments</p>
                <p class="text-white mb-0 ">Easy pay your customers, shops.</p>
                <p class="text-white mb-0 ">Track As you Go!</p>
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75"
                                                                  :src="`${publicPath}images/vaults-authlogo.png`">
                </h3>
                <h3 class="card-title font-weight-bold mb-1">Verify the Otp!</h3>
                <p class="card-text mb-2">Please enter the otp we sent to you email address</p>
                <Form class="auth-login-form mt-2" @submit="sendCall" :validation-schema="schema"
                      :initial-values="{email: email}">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <Field name="email" class="form-control" type="email" placeholder="Email" v-model="email" disabled/>
                    <ErrorMessage name="email" class="text-danger"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">OTP</label>
<!--                    <Field name="otp" class="form-control" type="text" placeholder="OTP" v-model="otp"/>-->
<!--                    <ErrorMessage name="otp" class="text-danger" />-->
                    <div id="otp" class="inputs d-flex flex-row justify-content-center mt-sm-25 mb-1" @paste="handlePaste" @keydown="handleKeyDown">
                      <input class=" text-center form-control rounded" type="text" id="first" maxlength="1"  />
                      <input class="ml-sm-75 text-center form-control rounded" type="text" id="second"  maxlength="1" />
                      <input class="ml-sm-75 text-center form-control rounded" type="text" id="third"  maxlength="1" />
                      <input class="ml-sm-75 text-center form-control rounded" type="text" id="fourth"  maxlength="1" />
                      <input class="ml-sm-75 text-center form-control rounded" type="text" id="fifth"  maxlength="1" />
                      <input class="ml-sm-75 text-center form-control rounded" type="text" id="sixth"  maxlength="1"  />
                    </div>
                    <span role="alert" class="text-danger" v-show="optValidate">The otp field is required</span>
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Send</Button>
                  </div>
                </form>
                <p class="text-center mt-2"><a @click="$router.push({name:'send-otp'})" href="javascript:void(0)"><span>Want To Change Your Email?</span></a></p>
                <p v-show="countDown == 0" class="text-center mt-2"><span>Don't get it?</span><a @click="ResendOtpCall" href="javascript:void(0)"><span>&nbsp;Resend Otp Now</span></a></p>
                <p v-show="countDown > 0" class="text-center mt-2">Resend Otp in <span class="text-danger font-weight-bolder font-large-1" >{{ countDown }}</span> seconds</p>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.countDownTimer()
  },
  mounted() {
    window.otpInit()
    if (typeof (this.$route.params.email) == 'undefined') {
      let email = localStorage.getItem('email');
      if (email != '' && email !== null) {
        this.email = email
      } else {
        this.$router.push({name: 'send-otp'});
      }
    } else {
      this.email = this.$route.params.email
    }

  },
  data() {
    return {
      loader: false,
      email: '',
      otp: '',
      countDown : 30,
      num1:'',
      num2:'',
      num3:'',
      num4:'',
      num5:'',
      num6:'',
      optValidate: false

    }
  },
  methods: {
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste behavior
      this.distributePastedText(event.clipboardData.getData('text'));
    },

    async handleKeyDown(event) {
      // Check for `Ctrl + V` or `Command + V`
      if ((event.ctrlKey || event.metaKey) && event.key === 'v') {
        event.preventDefault(); // Prevent the default paste behavior

        try {
          // Read the clipboard text
          const pastedText = await navigator.clipboard.readText();
          this.distributePastedText(pastedText);
        } catch (error) {
          console.error('Failed to read clipboard text:', error);
        }
      }
    },

    distributePastedText(pastedText) {
      // Split the pasted text into individual characters
      const otpDigits = pastedText.split('');

      // Distribute the digits to the input fields
      const inputs = document.querySelectorAll('#otp input');
      otpDigits.forEach((digit, index) => {
        if (inputs[index]) {
          inputs[index].value = digit;
        }
      });

      // Optionally, focus on the next empty input field
      for (let i = 0; i < inputs.length; i++) {
        if (!inputs[i].value) {
          inputs[i].focus();
          break;
        }
      }
    },
    ResendOtpCall(){

      let data ={
        "email": this.email
      }
      this.loader = true
      this.makeRequest('post','v1/verify-email',data).then(callResponse => {

        this.loader = false
        if(!callResponse.error){
          let code = callResponse.response.data.code;

          if(code == 200){
            localStorage.setItem('email',this.email);
            this.$router.push({name: 'verify-otp', params: { email: this.email }})
            this.countDown = 10
            this.countDownTimer()
          }
        }

      });

    },
    countDownTimer() {
      if(this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    goToSendOtp() {
      this.$router.push({name: 'send-otp'});
    },
    sendCall() {
     let first =  document.getElementById('first').value
     let second =  document.getElementById('second').value
     let third =  document.getElementById('third').value
     let fourth =  document.getElementById('fourth').value
     let fifth =  document.getElementById('fifth').value
     let sixth =  document.getElementById('sixth').value

      if(first == '' || second == '' || third == '' || fourth == '' || fifth == '' || sixth == ''){
        this.optValidate = true
        return
      }
      else{
        this.optValidate = false
      }
     this.otp = ''+first+second+third+fourth+fifth+sixth

      let data = {
        "email": this.email,
        "otp": this.otp,
      }
      this.loader = true
      this.makeRequest('post', 'v1/verify-otp', data).then(callResponse => {

        this.loader = false

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let accountExist = callResponse.response.data.data.accountExist;

            localStorage.setItem('email', this.email);
            if (accountExist == 1) {
              this.$router.push({name: 'login', params: {email: this.email}});
            } else {
              this.$router.push({name: 'signup', params: {email: this.email}});
            }
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
  },
}
</script>

